import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const DIAS = [
  { code: 'L', label: 'Lunes' },
  { code: 'M', label: 'Martes' },
  { code: 'X', label: 'Miércoles' },
  { code: 'J', label: 'Jueves' },
  { code: 'V', label: 'Viernes' },
  { code: 'S', label: 'Sábado' },
  { code: 'D', label: 'Domingo' },
];

/**
 * Grid L-D con inputs de horas por día. Uso:
 *   <HorarioSemanalInput value={{L:8,M:8,...}} onChange={h => setForm({...form, horario_semanal: h})} />
 * Los días vacíos se traducen a 0 (día no laborable). Rango permitido: 0-24h.
 */
export default function HorarioSemanalInput({ value = {}, onChange, disabled = false, testidPrefix = 'hs' }) {
  const setDia = (code, v) => {
    const n = v === '' ? null : Math.max(0, Math.min(24, parseFloat(v) || 0));
    onChange({ ...value, [code]: n });
  };
  return (
    <div className="grid grid-cols-7 gap-2" data-testid={`${testidPrefix}-grid`}>
      {DIAS.map(({ code, label }) => (
        <div key={code} className="flex flex-col items-center">
          <Label className="text-xs mb-1 text-zinc-600">{label.slice(0, 3)}</Label>
          <Input
            type="number"
            min="0"
            max="24"
            step="0.5"
            value={value?.[code] ?? ''}
            onChange={(e) => setDia(code, e.target.value)}
            disabled={disabled}
            placeholder="0"
            className="h-9 text-center text-sm"
            data-testid={`${testidPrefix}-${code}`}
          />
        </div>
      ))}
    </div>
  );
}
